import React from "react";
import { LabeledText } from "../../../components/LabeledText/LabeledText";
import { TwoColumnsLayout } from "../../../components/TwoColumnsLayout/TwoColumnsLayout";
import { Company } from "../../../interfaces/data";
import { useTranslation } from "react-i18next";
import { findCountry } from "../../../helpers/findCountry";

interface ContactAddressProps {
  company: Company;
}

export function ContactAddress({ company }: ContactAddressProps) {
  const { t } = useTranslation();
  return (
    <TwoColumnsLayout>
      <LabeledText label={t("company:Street")} value={company.contactAddress?.street} />
      <LabeledText label={t("company:Apt number")} value={company.contactAddress?.number} />
      <LabeledText label={t("company:Code")} value={company.contactAddress?.code} />
      <LabeledText label={t("company:City")} value={company.contactAddress?.city} />
      <LabeledText label={t("company:Country")} value={findCountry(company.contactAddress?.country)} />
    </TwoColumnsLayout>
  );
}
